import _css from "@emotion/css";
import { jsx as ___EmotionJSX } from "@emotion/core";
import React from 'react';
import PropTypes from 'prop-types';
import MUIList from '@material-ui/core/List';
import style from "./List.style";

const List = ({
  children,
  component,
  className,
  compact,
  role
}) => ___EmotionJSX(MUIList, {
  component: component,
  role: role,
  css:
  /*#__PURE__*/
  _css([style.list.base, compact && style.list.compact], "label:List;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3RtcC93ZWIvY29tcG9uZW50cy9MaXN0L0xpc3QuanMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBV0kiLCJmaWxlIjoiLi4vLi4vLi4vLi4vdG1wL3dlYi9jb21wb25lbnRzL0xpc3QvTGlzdC5qcyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCBmcm9tICdyZWFjdCc7XG5pbXBvcnQgUHJvcFR5cGVzIGZyb20gJ3Byb3AtdHlwZXMnO1xuaW1wb3J0IE1VSUxpc3QgZnJvbSAnQG1hdGVyaWFsLXVpL2NvcmUvTGlzdCc7XG5pbXBvcnQgc3R5bGUgZnJvbSAnLi9MaXN0LndlYi5zdHlsZSc7XG5cbmNvbnN0IExpc3QgPSAoe1xuICBjaGlsZHJlbiwgY29tcG9uZW50LCBjbGFzc05hbWUsIGNvbXBhY3QsIHJvbGUsXG59KSA9PiAoXG4gIDxNVUlMaXN0XG4gICAgY29tcG9uZW50PXtjb21wb25lbnR9XG4gICAgcm9sZT17cm9sZX1cbiAgICBjc3M9e1tcbiAgICAgIHN0eWxlLmxpc3QuYmFzZSxcbiAgICAgIGNvbXBhY3QgJiYgc3R5bGUubGlzdC5jb21wYWN0LFxuICAgIF19XG4gICAgY2xhc3NOYW1lPXtjbGFzc05hbWV9XG4gID5cbiAgICB7Y2hpbGRyZW59XG4gIDwvTVVJTGlzdD5cbik7XG5cbkxpc3QuZGVmYXVsdFByb3BzID0ge1xuICBjb21wb25lbnQ6ICd1bCcsXG4gIHJvbGU6ICcnLFxuICBjaGlsZHJlbjogW10sXG4gIGNsYXNzTmFtZTogdW5kZWZpbmVkLFxuICBjb21wYWN0OiBmYWxzZSxcbn07XG5cbkxpc3QucHJvcFR5cGVzID0ge1xuICBjb21wb25lbnQ6IFByb3BUeXBlcy5lbGVtZW50VHlwZSxcbiAgcm9sZTogUHJvcFR5cGVzLnN0cmluZyxcbiAgY2hpbGRyZW46IFByb3BUeXBlcy5ub2RlLFxuICBjbGFzc05hbWU6IFByb3BUeXBlcy5zdHJpbmcsXG4gIGNvbXBhY3Q6IFByb3BUeXBlcy5ib29sLFxufTtcblxuZXhwb3J0IGRlZmF1bHQgUmVhY3QubWVtbyhMaXN0KTtcbiJdfQ== */")),
  className: className
}, children);

List.defaultProps = {
  component: 'ul',
  role: '',
  children: [],
  className: undefined,
  compact: false
};
List.propTypes = {
  component: PropTypes.elementType,
  role: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  compact: PropTypes.bool
};
export default React.memo(List);